export default "__VITE_ASSET__BBFY106H__"